import React from "react";
import "./ContainerizationBuild.css";

export default function ContainerizationBuild() {
  return (
    <div id="containerization-build" className="outsourcemainclass">
      <div className="left">
        <h2 className="heading">
          Powering Faster Delivery with DevOps Automation
        </h2>
        <p className="subheading">
          At BastionEx, we deliver intelligent DevOps automation services that
          accelerate deployments, streamline workflows, and improve software
          reliability. Our solutions reduce manual effort, enhance
          collaboration, and enable continuous delivery for scalable,
          high-performance operations.
        </p>
        <button>Book your free consultation</button>
      </div>
    </div>
  );
}
